(ns notification.events
  (:require
    [very.re-frame.core :as rf]))

(rf/reg-sub
 :notification
 (fn [db]
   (:notification-message db)))

(rf/reg-event-fx
 :success-message
 (fn [cfx [msg]]
   {:db (assoc (:db cfx) :notification-message {:message msg
                                                :status :success})
    :dispatch-later [{:ms 5000 :dispatch [:remove-message]}]}))

(rf/reg-event-fx
  :error-message
  (fn [cfx [msg]]
    {:db (assoc (:db cfx) :notification-message {:message msg
                                                 :status :error})
     :dispatch-later [{:ms 5000 :dispatch [:remove-message]}]}))

(rf/reg-event-db
 :remove-message
 (fn [db]
   (dissoc db :notification-message)))
